<template>
  <div class="paymentConvenience">
    <div class="paymentConvenience__text">下記コンビニでお支払いいただけます。</div>
    <div class="paymentConvenience__note">
      {{ item.paymentLimitAt | datetime }}までにご入金ください。<br>
      ※期限までに入金が確認できない場合キャンセルされます
    </div>
    <div class="paymentConvenience__img">
      <img src="/static/img/academy/convenience2.png" alt="" />
    </div>
    <form
      ref="form"
      :action="sbps.sbpsApiUrl"
      method="post"
      accept-charset="Shift_JIS"
      @submit.prevent
    >
      <input v-for="(v, k) in filterWebcvs" :key="k" type="hidden" :name="k" :value="v" />
      <input type="hidden" name="amount" :value="price">
      <div class="paymentConvenience__notice">
        ※商品のご提供時期、お支払い時期、キャンセルについては<a href="https://www.uranai-academy.jp/legal" target="_blank">こちら</a>をご確認ください。
      </div>
      <base-button text="次へ" @click="submit" />
    </form>
  </div>
</template>

<script>
import BaseButton from '../partials/BaseButton'

export default {
  name: 'PaymentConvenience',
  components: {
    BaseButton,
  },
  props: {
    sbps: Object,
    webcvs: Object,
    price: Number,
    item: Object,
  },
  computed: {
    filterWebcvs() {
      let obj = Object.assign({}, this.webcvs)
      delete obj.amount
      return obj
    },
  },
  methods: {
    submit() {
      this.$refs.form.submit()
    },
  },
  filters: {
    datetime(value) {
      // 2022年3月1日の23時59分
      // safari の bug の為、- を / に置換してから処理
      const dt = new Date(value.replace(/-/g,"/"))
      return `${dt.getFullYear()}年${dt.getMonth() + 1}月${dt.getDate()}日の${dt.getHours()}時${dt.getMinutes()}分`
    },
  },
}
</script>

<style lang="scss" scoped>
.paymentConvenience {
  &__text {
    font-size: 13px;
    margin: 0 0 10px;
  }
  &__note {
    background: #FFF3F7;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 12px;
  }
  &__img {
    border: 1px solid #D8D8D8;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 20px;
    margin: 0 auto 35px;
    text-align: center;
    > img {
      width: 100%;
      vertical-align: middle;
    }
  }
  &__notice {
    margin: -15px 0 30px;
    color: #9081C8;
    font-size: 12px;
    line-height: 1.2;
  }
}
</style>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/PaymentConvenience.vue